import React, { useState, useEffect } from 'react';
import { PortalCard, SVBTypography } from '@svb/svb-react-components';
import { slugCreator } from '../../../core/useStore';

export default function SVBFaqMostCommonResult(props) {
  const [mounted, setMounted] = useState(false);
  const sub_Heading_Faqs = 'Most Common Questions';
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(props?.cardJson);
    setMounted(true);
  }, []);

  if (!mounted) {
    return <></>;
  }
  return (
    <>
      <div className='col-md-12 col-sm-12 pt-4 pb-4'>
        <SVBTypography type='heading-large' variant='heading-medium'>
          {sub_Heading_Faqs}
        </SVBTypography>
      </div>
      {data?.map((faqData, i) => {
        let faq_tags = [];
        faqData?.tags?.filter(
          (item) =>
            item.name !== 'common' &&
            item.value &&
            faq_tags.push({ label: item.value, type: 'svb-label_category-tag_type-faq' }),
        );

        const faq_mostcommon = faqData?.tags?.find(
          (item) => item.name === 'common' && item.value[0] === 'true',
        );
        return faq_mostcommon ? (
          <div
            className='col-md-6 col-sm-6 pb-4'
            role='button'
            key={i}
            data-testid={slugCreator(faqData?.title)}
          >
            <PortalCard
              data={{
                title: faqData.title,
                description: faqData.description,
                tags: faq_tags,
                action: {
                  type: 'card',
                  href: `/faqs/${slugCreator(faqData?.title)}`,
                },
              }}
            />
          </div>
        ) : null;
      })}
    </>
  );
}
